/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import { Avatar } from '@mui/material';
import debounce from 'lodash.debounce';
import { Breadcrumb, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import { usePageTitle } from '../../../../App';
import { CustomTable } from '../../../../components';
import CustomTooltip from '../../../../components/CustomTooltips';
import { VENDOR_IMAGE_URL } from '../../../../constants/Config';
import { vendorsTableData } from '../../../../constants/TableHeaderConstants';
import { truncateString } from '../../../../utils/TruncateStringUtils';
import { getUserInfo } from '../../../../utils/UserInfoUtils';
import { vendorsFilterRequest, vendorsRequest } from '../actions';

const Vendors = ({
  handleCloseProofReaderVendorFileFilter,
  handleVendorFilterClear,
  handleVendorFilter,
  currentPage,
  setCurrentPage,
  proofReaderAllFileFilterModal,
  setProofReaderAllFileFilterModal,
  filterStatusData,
  setFilterStatusData,
  filterVendorLanguageData,
  setFilterVendorLanguageData,
  filterGroupData,
  setFilterGroupData,
  filterRatingData,
  setFilterRatingData,
  filterVendorClientData,
  setFilterVendorClientData,
  filterApiCall,
  setFilterApiCall,
}) => {
  usePageTitle('Datagain Transcription  - Vendors'); // Set tab title

  const dispatch = useDispatch();
  const userId = getUserInfo()?.UserId;
  const [searchValue, setSearchValue] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortField, setSortField] = useState('Name');
  const [sortOrder, setSortOrder] = useState(1);

  // Use useLocation hook to listen for route changes
  const location = useLocation();

  // Reset states whenever the route changes
  useEffect(() => {
    setSearchValue('');
    setRowsPerPage(10);
    setCurrentPage(0);
    setSortField('Name');
    setSortOrder(1);
    setProofReaderAllFileFilterModal(false);
    setFilterStatusData(0);
    setFilterVendorLanguageData(0);
    setFilterGroupData('');
    setFilterRatingData(0);
    setFilterVendorClientData(null);
    setFilterApiCall(false);
  }, [location]); // This effect runs every time the location (route) changes

  const loadingFilter = false;

  const handleShow = () => setProofReaderAllFileFilterModal(true);

  // Api's loading
  let loading = useSelector((state) => state?.vendorsList?.loading);

  let vendorsFileDataTable = useSelector((state) => state?.vendorsList?.user?.data?.value);

  let vendorFilter = useSelector((state) => state?.vendorsFilterList?.user?.data?.value);

  // Vendors file's Data
  let vendorsFiles = vendorsFileDataTable && JSON.parse(vendorsFileDataTable);

  let vendorsFilterList = vendorFilter && JSON.parse(vendorFilter);

  // Vendors file's API data
  let vendorsFilesData =
    vendorsFiles?.ObjList !== null || vendorsFiles?.ObjList !== undefined ? vendorsFiles?.ObjList : [];

  // Debounced search function
  useEffect(() => {
    const debouncedSearch = debounce((value) => {}, 2000);
    debouncedSearch(searchValue);
    return () => {
      debouncedSearch.cancel();
    };
  }, [searchValue]);

  // Table data serach function
  const handleSearch = (event) => {
    const debouncedFilter = debounce(() => {
      const value = event.target.value;
      setCurrentPage(0);
      setSearchValue(value);
    }, 2000);
    debouncedFilter();
  };

  // Table data sorting function
  const handleSortChange = (event) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
    setCurrentPage(0);
  };

  // Table data set for use this function
  useEffect(() => {
    var params = {
      page: currentPage + 1,
      rowNumber: rowsPerPage,
      sortRowName: sortField,
      sortRowDirection: sortOrder === 1 ? 'asc' : 'desc',
      search: searchValue,
      filter: {
        userId: userId,
        status: parseInt(filterStatusData),
        groupId: filterGroupData,
        languageId: parseInt(filterVendorLanguageData),
        rating: filterRatingData === '' ? 0 : parseInt(filterRatingData),
        clientId: filterVendorClientData === '' ? null : filterVendorClientData,
      },
    };
    dispatch(vendorsRequest(params));
    setFilterApiCall(false);
  }, [dispatch, currentPage, rowsPerPage, sortField, sortOrder, searchValue, userId, filterApiCall === true]);

  useEffect(() => {
    dispatch(vendorsFilterRequest());
    setFilterApiCall(false);
  }, [dispatch]);

  // Custom body template for Vendor name on column
  const nameTemplate = (rowData) => {
    return (
      <>
        <div className="d-flex d-flex align-items-center">
          <Avatar
            alt="image"
            src={
              rowData?.ProfilePicture !== null && rowData?.ProfilePicture
                ? `${VENDOR_IMAGE_URL}/${rowData?.ProfilePicture}`
                : null
            }
            className="submit-profile-avatar me-2"
          />
          {rowData?.Name}
        </div>
      </>
    );
  };

  // Custom body template for Vendor Rate on column
  const rateTemplate = (rowData) => {
    return <>{rowData?.Rate !== null ? <div>{rowData?.Rate}</div> : <div>--</div>}</>;
  };

  // Custom body template for Vendor Rating on column
  const ratingTemplate = (rowData) => {
    return <>{rowData?.Rating !== null ? <div>{rowData?.Rating}</div> : <div>--</div>}</>;
  };

  // Custom body template for Vendor Expertise on column
  const expertiseTemplate = (rowData) => {
    return <>{rowData?.Expertise !== null ? <div>{rowData?.Expertise}</div> : <div>--</div>}</>;
  };

  // Custom body template for Vendor Language on column
  const languageTemplate = (rowData) => {
    return <>{rowData?.Language !== null ? <div>{rowData?.Language}</div> : <div>--</div>}</>;
  };

  // Custom body template for Vendor Country on column
  const countryTemplate = (rowData) => {
    return <>{rowData?.Country !== null ? <div>{rowData?.Country}</div> : <div>--</div>}</>;
  };

  // Custom body template for Vendor Groups on column
  const groupTemplate = (rowData) => {
    return (
      <>
        {rowData?.Groups !== null ? (
          <div>
            <CustomTooltip title={rowData?.Groups} placement="bottom">
              {truncateString(rowData?.Groups, 25)}
            </CustomTooltip>
          </div>
        ) : (
          <div>--</div>
        )}
      </>
    );
  };

  // Modification table cell
  const bodyTemplates = {
    Name: nameTemplate,
    Groups: groupTemplate,
    Rating: ratingTemplate,
    Rate: rateTemplate,
    Expertise: expertiseTemplate,
    Language: languageTemplate,
    Country: countryTemplate,
  };

  const selectStyles = {
    control: (base) => ({
      ...base,
      height: '50px',
      minWidth: '200px',
      border: '1px solid #e6e6e6',
      borderRadius: '4px',
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, // Ensure the dropdown is above the modal
    }),
  };

  return (
    <span>
      <Row>
        <Col className="d-flex align-items-center">
          <div className="mainTitle">
            <Breadcrumb>
              <Breadcrumb.Item>All Vendors</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>
        <Col md="auto" className="d-flex align-items-center mb-3 gap-3">
          <Form className="search-group main-search-group">
            <Form.Group className="search-group" controlId="exampleForm.ControlInput1">
              <Form.Control
                className="border-0"
                type="text"
                placeholder="Search"
                onChange={handleSearch}
                onKeyDown={(e) => {
                  if (e.keyCode === 13 || e.key === 'Enter') {
                    e.preventDefault();
                  }
                }}
                autoComplete="off"
              />
              <span>
                <SearchRoundedIcon />
              </span>
            </Form.Group>
          </Form>
          <button className="filter-btn cursor-pointer" onClick={handleShow} style={{ background: 'transparent' }}>
            <TuneRoundedIcon />
          </button>
        </Col>
      </Row>
      <Row>
        <Col xs="12" style={{ marginBottom: 50 }}>
          <div className="card-widget">
            <CustomTable
              tableData={vendorsTableData}
              filteredCustomers={vendorsFilesData ? vendorsFilesData : []}
              totalRecords={vendorsFiles?.noOfRecords}
              rowsPerPage={rowsPerPage}
              sortOrder={sortOrder}
              sortField={sortField}
              setRowsPerPage={setRowsPerPage}
              handleSortChange={handleSortChange}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setFilterApiCall={setFilterApiCall}
              bodyTemplates={bodyTemplates}
              loading={loading}
              checkbox={false}
            />
          </div>
        </Col>
      </Row>
      <Modal
        show={proofReaderAllFileFilterModal}
        onHide={handleCloseProofReaderVendorFileFilter}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal"
      >
        <div>
          <div className="preview-dropdown-header">
            Filter By
            <HighlightOffRoundedIcon
              onClick={handleCloseProofReaderVendorFileFilter}
              className="cursor-pointer opacity-50"
              style={{ height: '28px', width: '28px' }}
            />
          </div>
          <div className="preview-dropdown-body">
            {loadingFilter ? (
              <div className="text-center my-5">
                <Spinner animation="border" />
              </div>
            ) : (
              <Row>
                <Col md="4" className="mb-3">
                  <label>Status</label>
                  <Select
                    value={
                      filterStatusData
                        ? {
                            value: filterStatusData,
                            label: vendorsFilterList?.StatusList.find((option) => option.Id === filterStatusData)?.Name,
                          }
                        : { value: 0, label: 'Show All' }
                    }
                    onChange={(selectedOption) => setFilterStatusData(selectedOption ? selectedOption.value : 0)}
                    options={[
                      { value: 0, label: 'Show All' },
                      ...(vendorsFilterList?.StatusList.map((option) => ({
                        value: option.Id,
                        label: option.Name,
                      })) || []),
                    ]}
                    isSearchable
                    placeholder="Select Status"
                    styles={selectStyles}
                    classNamePrefix="custom-select"
                    menuPortalTarget={document.body} // Render dropdown outside the modal
                  />
                </Col>

                <Col md="4" className="mb-3">
                  <label>Language</label>
                  <Select
                    value={
                      filterVendorLanguageData
                        ? {
                            value: filterVendorLanguageData,
                            label: vendorsFilterList?.LanguageList.find(
                              (option) => option.Id === filterVendorLanguageData,
                            )?.Name,
                          }
                        : { value: 0, label: 'Show All' }
                    }
                    onChange={(selectedOption) =>
                      setFilterVendorLanguageData(selectedOption ? selectedOption.value : 0)
                    }
                    options={[
                      { value: 0, label: 'Show All' },
                      ...(vendorsFilterList?.LanguageList.map((option) => ({
                        value: option.Id,
                        label: option.Name,
                      })) || []),
                    ]}
                    isSearchable
                    placeholder="Select Language"
                    styles={selectStyles}
                    classNamePrefix="custom-select"
                    menuPortalTarget={document.body} // Render dropdown outside the modal
                  />
                </Col>

                <Col md="4" className="mb-3">
                  <label>Group</label>
                  <Select
                    value={
                      filterGroupData
                        ? {
                            value: filterGroupData,
                            label: vendorsFilterList?.GroupList.find((option) => option.Id === filterGroupData)?.Name,
                          }
                        : { value: '', label: 'Show All' }
                    }
                    onChange={(selectedOption) => setFilterGroupData(selectedOption ? selectedOption.value : '')}
                    options={[
                      { value: '', label: 'Show All' },
                      ...(vendorsFilterList?.GroupList.map((option) => ({
                        value: option.Id,
                        label: option.Name,
                      })) || []),
                    ]}
                    isSearchable
                    placeholder="Select Group"
                    styles={selectStyles}
                    classNamePrefix="custom-select"
                    menuPortalTarget={document.body} // Render dropdown outside the modal
                  />
                </Col>

                <Col md="4" className="mb-3">
                  <label>Rating</label>
                  <Select
                    value={
                      filterRatingData
                        ? {
                            value: filterRatingData,
                            label: vendorsFilterList?.RatingList.find((option) => option.Id === filterRatingData)?.Name,
                          }
                        : { value: 0, label: 'Show All' }
                    }
                    onChange={(selectedOption) => setFilterRatingData(selectedOption ? selectedOption.value : 0)}
                    options={[
                      { value: 0, label: 'Show All' },
                      ...(vendorsFilterList?.RatingList.map((option) => ({
                        value: option.Id,
                        label: option.Name,
                      })) || []),
                    ]}
                    isSearchable
                    placeholder="Select Rating"
                    styles={selectStyles}
                    classNamePrefix="custom-select"
                    menuPortalTarget={document.body} // Render dropdown outside the modal
                  />
                </Col>

                <Col md="4" className="mb-3">
                  <label>Client</label>
                  <Select
                    value={
                      filterVendorClientData
                        ? {
                            value: filterVendorClientData,
                            label: vendorsFilterList?.ClientList.find((option) => option.Id === filterVendorClientData)
                              ?.Name,
                          }
                        : { value: '', label: 'Show All' }
                    }
                    onChange={(selectedOption) => setFilterVendorClientData(selectedOption ? selectedOption.value : '')}
                    options={[
                      { value: '', label: 'Show All' },
                      ...(vendorsFilterList?.ClientList.map((option) => ({
                        value: option.Id,
                        label: option.Name,
                      })) || []),
                    ]}
                    isSearchable
                    placeholder="Select Client"
                    styles={selectStyles}
                    classNamePrefix="custom-select"
                    menuPortalTarget={document.body} // Render dropdown outside the modal
                  />
                </Col>
                <Col md="12" className="text-end mt-5">
                  <Button
                    variant="outline-secondary"
                    onClick={handleVendorFilterClear}
                    className="me-2"
                    style={{ height: '45.49px', fontWeight: 600 }}
                  >
                    Clear Filter
                  </Button>
                  <Button
                    variant="primary"
                    onClick={handleVendorFilter}
                    className="ms-2"
                    style={{ height: '45.49px', fontWeight: 600 }}
                  >
                    Filter
                  </Button>
                </Col>
              </Row>
            )}
          </div>
        </div>
      </Modal>
    </span>
  );
};

export default Vendors;
